module.exports = __webpack_public_path__ + "static/img/tips1.54c7a300.png";